import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";


const GroheFeatureSoldOut = (props) => {
  const {disabled, intl, fabricatorData} = props;
  if (!disabled) {
    return null
  }

  return (
    <div className="grohe-sold">
      {fabricatorData.isAmericanStandard ? null : (
        <IconButton aria-label={intl.formatMessage({id:"iconButton.info"})}
                    className="look-icon look-icon--small look-icon--yellow">
          <ErrorIcon/>
        </IconButton>
      )}
      <span className="grohe-sold__text bold">
        <FormattedMessage id="grohe.feature.soldOut" />
      </span>
    </div>
  )
};

GroheFeatureSoldOut.propTypes = {
  disabled: PropTypes.bool
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData
  }
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureSoldOut)
)
